import React, {CSSProperties} from "react";
import WhatsAppIcon from "./WhatsApp.svg";

export interface LogoProps {
    style?: CSSProperties
}

const WhatsApp = ({style}: LogoProps) => {
    return (
        <div className="one-by-one-container" style={style}>
            <div className="one-by-one-content">
                <img alt="WhatsApp" src={WhatsAppIcon} style={{width: "100%", height: "100%"}}/>
            </div>
        </div>
    );
}

export default WhatsApp;